export const API_URL = "https://api.{0}/authinfra-app";
export const API_URL_ADMINS = "{0}/admins";
export const API_URL_ADMINS_GET = "{0}/admins?email={1}";
export const API_URL_UPLOAD = "{0}/upload?filename={1}";
export const API_URL_APPUSERS = "{0}/appusers";

export const REDIRECT_URI = "https://{0}/completed";
export const COGNITO_URL = "https://cognito.{0}/login?response_type=code&client_id={1}&redirect_uri={2}";
